import React from "react";
import { ReactSVG } from "react-svg";
import asset from "assets/images";

const RoleUserCount = ({ count = 0 }) => {
    const userLabel = count === 1 ? "user" : "users";

    return (
        <div
            className={`role-user-count ${
                count === 0 ? "role-user-count--empty" : ""
            }`}>
            <ReactSVG
                src={asset?.icons?.addUser}
                className='role-user-count__icon'
            />
            <span className='role-user-count__value'>{count}</span>
            <span className='role-user-count__label'>{userLabel}</span>
        </div>
    );
};

export default RoleUserCount;
